import { render, staticRenderFns } from "./Placement_Groups.vue?vue&type=template&id=23a8266f&scoped=true"
import script from "./Placement_Groups.vue?vue&type=script&lang=js"
export * from "./Placement_Groups.vue?vue&type=script&lang=js"
import style0 from "./Placement_Groups.vue?vue&type=style&index=0&id=23a8266f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8266f",
  null
  
)

export default component.exports